import { render, staticRenderFns } from "./RegistroCargador.vue?vue&type=template&id=bd123e98&scoped=true"
import script from "./RegistroCargador.vue?vue&type=script&lang=js"
export * from "./RegistroCargador.vue?vue&type=script&lang=js"
import style0 from "./RegistroCargador.vue?vue&type=style&index=0&id=bd123e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd123e98",
  null
  
)

export default component.exports